{
  "actionbar.actions": "Toimingud",
  "actionbar.actionsAvailable": "Toimingud saadaval.",
  "actionbar.clearSelection": "Puhasta valik",
  "actionbar.selected": "{count, plural, =0 {Pole valitud} other {# valitud}}",
  "actionbar.selectedAll": "Kõik valitud",
  "breadcrumbs.more": "Veel üksusi",
  "button.pending": "ootel",
  "calendar.invalidSelection": "Valitud {selectedCount, plural, one {kuupäev} other {kuupäevad}} pole saadaval.",
  "combobox.noResults": "Tulemusi pole",
  "contextualhelp.help": "Spikker",
  "contextualhelp.info": "Teave",
  "datepicker.endTime": "Lõpuaeg",
  "datepicker.startTime": "Algusaeg",
  "datepicker.time": "Aeg",
  "dialog.alert": "Teade",
  "dialog.dismiss": "Lõpeta",
  "dropzone.replaceMessage": "Kukuta fail asendamiseks",
  "inlinealert.informative": "Teave",
  "inlinealert.negative": "Viga",
  "inlinealert.notice": "Hoiatus",
  "inlinealert.positive": "Valmis",
  "label.(optional)": "(valikuline)",
  "label.(required)": "(nõutav)",
  "menu.moreActions": "Veel toiminguid",
  "menu.unavailable": "Pole kättesaadav, üksikasjade vaatamiseks laiendage",
  "notificationbadge.indicatorOnly": "Uus tegevus",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Valige…",
  "picker.selectedCount": "{count, plural, =0 {üksuseid pole valitud} one {# üksus valitud} other {# üksust valitud}}",
  "slider.maximum": "Maksimaalne",
  "slider.minimum": "Minimaalne",
  "table.cancel": "Tühista",
  "table.drag": "Lohista",
  "table.editCell": "Muuda lahtrit",
  "table.loading": "Laadimine...",
  "table.loadingMore": "Laadi rohkem...",
  "table.resizeColumn": "Muuda veeru suurust",
  "table.save": "Salvesta",
  "table.sortAscending": "Sordi kasvavalt",
  "table.sortDescending": "Sordi kahanevalt",
  "tag.actions": "Toimingud",
  "tag.hideButtonLabel": "Kuva vähem",
  "tag.noTags": "Puudub",
  "tag.showAllButtonLabel": "Kuva kõik ({tagCount, number})",
  "toast.clearAll": "Tühjenda kõik",
  "toast.collapse": "Ahenda",
  "toast.showAll": "Kuva kõik"
}
